import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  paper: {
    minWidth: "468px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  subtitle: {
    color: theme.palette.primary.dark,
    fontSize: "1.4rem",
  },

  saveButton: {
    marginLeft: theme.spacing(2),
  },
  buttonLabel: {
    minWidth: "36px",
  },
  textfield: {
    marginBottom: theme.spacing(1.5),
  },
  saveText: {
    color: theme.palette.primary.dark,
    fontSize: "1.4rem",
    marginLeft: theme.spacing(1),
  },
  firstForm: {
    marginBottom: theme.spacing(5),
  },
  formHelperText: {
    marginLeft: "0px",
    position: "absolute",
    bottom: "-20px",
  },
}))

export default styles
